
import { useAuthStore } from "@/stores/authStore";
import { ProfileForm } from "@/components/profile/tabs/form/ProfileForm";
import { useProfile } from "@/hooks/useProfile";
import { Spinner } from "@/components/ui/Spinner";
import { toast } from "sonner";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useUserRole } from "@/hooks/useUserRole";

export function ProfileSettings() {
  const { user, isInitializing } = useAuthStore();
  const { userRole, isLoading: roleLoading } = useUserRole();
  const { profile, isLoading, error } = useProfile(user);

  // Show loading during auth initialization
  if (isInitializing) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  // Only show sign-in message after initialization completes
  if (!user) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Please sign in to access your profile settings
        </AlertDescription>
      </Alert>
    );
  }

  if (error && !profile) {
    // Only show error if we truly have no profile data at all
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-2">Loading Profile</h2>
          <p className="text-gray-600 mb-4">Having trouble loading your profile settings.</p>
          <button 
            onClick={() => window.location.reload()} 
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  if (roleLoading || isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {profile && <ProfileForm user={user} />}
    </div>
  );
}
